module.exports = __webpack_public_path__ + "img/img15.235636ff.png";